module.exports = __webpack_public_path__ + "img/road.5c3ef41c.svg";